/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsMatchTimelineEventDtoSchema = z.object({
  eventId: z.optional(z.int()),
  name: z.string().nullish(),
  timeSeconds: z.optional(z.number()),
  dataJson: z.string().nullish(),
});
